// GENERATED by scripts/gen.mjs - do not edit (git-ignored; BUILD-PLAN §4 rule 3).
export const screenModules = [
  { dir: 'admin', load: () => import('../routes/admin/index.tsx') },
  { dir: 'ap', load: () => import('../routes/ap/index.tsx') },
  { dir: 'ar-bank', load: () => import('../routes/ar-bank/index.tsx') },
  { dir: 'close', load: () => import('../routes/close/index.tsx') },
  { dir: 'costing', load: () => import('../routes/costing/index.tsx') },
  { dir: 'cutting', load: () => import('../routes/cutting/index.tsx') },
  { dir: 'd2c-orders', load: () => import('../routes/d2c-orders/index.tsx') },
  { dir: 'd2c-sync', load: () => import('../routes/d2c-sync/index.tsx') },
  { dir: 'development', load: () => import('../routes/development/index.tsx') },
  { dir: 'eta-freight', load: () => import('../routes/eta-freight/index.tsx') },
  { dir: 'fabric-trim', load: () => import('../routes/fabric-trim/index.tsx') },
  { dir: 'gl', load: () => import('../routes/gl/index.tsx') },
  { dir: 'labels', load: () => import('../routes/labels/index.tsx') },
  { dir: 'lots-quality', load: () => import('../routes/lots-quality/index.tsx') },
  { dir: 'masters', load: () => import('../routes/masters/index.tsx') },
  { dir: 'nl-assistant', load: () => import('../routes/nl-assistant/index.tsx') },
  { dir: 'notes', load: () => import('../routes/notes/index.tsx') },
  { dir: 'orders', load: () => import('../routes/orders/index.tsx') },
  { dir: 'partners', load: () => import('../routes/partners/index.tsx') },
  { dir: 'planning', load: () => import('../routes/planning/index.tsx') },
  { dir: 'po-import', load: () => import('../routes/po-import/index.tsx') },
  { dir: 'posting', load: () => import('../routes/posting/index.tsx') },
  { dir: 'programmes', load: () => import('../routes/programmes/index.tsx') },
  { dir: 'purchasing', load: () => import('../routes/purchasing/index.tsx') },
  { dir: 'reports', load: () => import('../routes/reports/index.tsx') },
  { dir: 'reports-std', load: () => import('../routes/reports-std/index.tsx') },
  { dir: 'sage-bridge', load: () => import('../routes/sage-bridge/index.tsx') },
  { dir: 'sewing-fg', load: () => import('../routes/sewing-fg/index.tsx') },
  { dir: 'shipping', load: () => import('../routes/shipping/index.tsx') },
  { dir: 'shipping-docs', load: () => import('../routes/shipping-docs/index.tsx') },
  { dir: 'specs-bom', load: () => import('../routes/specs-bom/index.tsx') },
  { dir: 'styles', load: () => import('../routes/styles/index.tsx') },
  { dir: 'warehouse', load: () => import('../routes/warehouse/index.tsx') },
] as const;
